import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import React, { useEffect, useState } from 'react';
import { FilterOptionValue, MappedFacet } from '@mybestbrands/types';
import styles from './filters.module.scss';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import ColorBox from '@/app/ui/components/filters/colorbox';

export function ColorsFilter({
  filter,
  isActive,
  toggleFilterOptions,
  onFilterUpdate,
  onApplySearchFilters,
}: {
  filter: FilterOptionValue | undefined;
  isActive: boolean;
  onApplySearchFilters: () => void;
  onFilterUpdate: (value: string[]) => void;
  toggleFilterOptions: () => void;
}) {
  const { t } = useTranslation('filters');
  const [filterOptions, setFilterOptions] = useState([] as MappedFacet[]);
  const selectedColors = filterOptions.filter((option) => option.checked).map((option) => option.value);

  useEffect(() => {
    if (!filter || !filter?.options?.length) return;

    setFilterOptions(filter.options);
  }, [filter?.options]);

  const Chevron = isActive ? ChevronUp : ChevronDown;

  if (!filter || !filter?.options?.length) return null;

  function onColorSelect(id: string) {
    const newFilterOptions = filterOptions.map((option) => {
      return option.id === id ? { ...option, checked: !option.checked } : option;
    });

    setFilterOptions(newFilterOptions);
    const selectedColors = newFilterOptions.filter((option) => option.checked).map((option) => option.value);

    onFilterUpdate(selectedColors);
  }

  return (
    <div
      key={filter.name}
      className={clsx(styles.filterDefaultZIndex, 'position-relative')}
      style={{
        zIndex: 2,
      }}>
      <div
        onClick={toggleFilterOptions}
        key={filter.name}
        className={clsx(
          'btn',
          'btn-white-hover-black',
          'lowercase',
          'd-flex',
          'justify-content-center',
          'align-items-center',
          styles.filter
        )}>
        <span className="me-1">{t(filter.name)}</span>
        {!!selectedColors.length && (
          <span className={clsx(styles.filtercounter)}>
            <span className="position-relative" style={{ bottom: '1px' }}>
              {selectedColors.length}
            </span>
          </span>
        )}
        <Chevron className="ms-2" />
      </div>
      {isActive && (
        <div
          className="position-absolute bg-white border border-dark p-2 filter-list"
          style={{ top: '35px', width: '18rem' }}>
          <div
            className={clsx('d-flex', 'flex-wrap', styles.colorsContainer)}
            style={{ gap: '0.3rem', paddingBottom: 1 }}>
            {filterOptions.map((option) => (
              <button
                key={option.name}
                style={{
                  flex: '0 0 31.8%',
                  textTransform: 'capitalize',
                  maxWidth: '100%',
                  fontSize: option.name.length > 10 ? '0.7rem' : '0.8rem',
                }}
                className={clsx(
                  'd-flex',
                  'pe-0',
                  'btn',
                  option.checked ? 'btn-black' : 'btn-white-hover-border',
                  'small'
                )}
                onClick={() => onColorSelect(option.id)}>
                <div style={{ marginLeft: '-0.5rem', marginRight: '0.2rem' }}>
                  <ColorBox color={option.id} />
                </div>
                <span style={{ whiteSpace: 'nowrap' }}>{option.name}</span>
              </button>
            ))}
          </div>
          <div className="position-relative">
            <button
              onClick={onApplySearchFilters}
              className="btn filter btn-white-hover-black lowercase mt-3 mb-2 w-100">
              {t('SAVE')}
              <span className="ms-1" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
